import React, { memo } from "react";
import { withStyles } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Clear from "@material-ui/icons/CancelOutlined";
import styles from "./styles";
import appConstants from "../../../appConstants";
import { debounce } from "lodash";

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
    this.debouncedEmit = debounce(this.emitSearchTextEvent, appConstants.SEARCH_DEBOUNCE_DELAY);
  }

  componentWillUnmount() {
    this.emitSearchTextEvent("");
    this.debouncedEmit.cancel();
  }

  onSearchTextChange = (event) => {
    const searchText = event.target.value;
    this.debouncedEmit(searchText);
    this.setState({ searchText });
  };

  emitSearchTextEvent = (searchText) => {
    this.props.eventHub.emit(this.props.headerId, searchText);
  };
  onClear = () => {
    this.setState({ searchText: "" }, () => {
      this.debouncedEmit.cancel();
      this.emitSearchTextEvent("");
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={`${classes.search} ${classes.iconLayout} glHeaderIcons`}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search…"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          onChange={this.onSearchTextChange}
          value={this.state.searchText}
          endAdornment={
            <Clear
              classes={{
                root: `${classes.clearIcon} ${
                  this.state.searchText
                    ? classes.iconVisible
                    : classes.iconHidden
                }`,
              }}
              onClick={this.onClear}
              display={this.state.searchText ? "none" : "block"}
            />
          }
        />
      </div>
    );
  }
}

export default withStyles(styles)(memo(SearchBar));
